<template>
  <q-list style="max-width: 400px; margin: 0 auto;">
    <q-item
      v-for="(duel, index) in data"
      :key="duel.id"
      @click.native="goToDuel(duel)"
      :disabled="!isDuelClickable(duel)"
      :class="{
        'q-mt-sm': index > 0,
        [getDuelColor(duel)]: true,
      }"
      dense
      ripple
      clickable
      class="text-center shadow-2 rounded-borders"
    >
      <q-item-section>
        <q-item-label
          caption
          class="text-white"
        >
          {{ duel.type }} duelers
          <template v-if="duel.status === DUEL_STATUSES.OPEN">
            (current:
            <strong class="text-bold">{{ duel.assignedPlayers }}</strong>)
          </template>
          <template v-if="duel.status === DUEL_STATUSES.CLOSED">
            (closed)
          </template>
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-list>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from 'vuex';
import { DUEL_STATUSES } from '@/helpers/constants';

@Component({
  name: 'list-duels',
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  computed: mapGetters(['activeDuelId']),
})
export default class ListDuels extends Vue {
  // !DATA
  DUEL_STATUSES = DUEL_STATUSES;

  // !METHODS
  getDuelColor(duel) {
    if (!this.isDuelClickable(duel)) {
      return 'bg-grey-6';
    }
    if (duel.status === DUEL_STATUSES.CLOSED) {
      return 'bg-green-8';
    }
    if (+duel.assignedPlayers < +duel.type) {
      return 'bg-teal-7';
    } else {
      return 'bg-red-8';
    }
  }
  goToDuel(duel) {
    if (!this.isDuelClickable(duel)) return;

    this.$router.push({
      name: 'duel',
      params: {
        id: this.$route.params.id,
        duelId: duel.id,
      },
    });
  }
  isDuelClickable(duel) {
    return (
      duel.isFilteredByUser ||
      (duel.status === DUEL_STATUSES.OPEN && +duel.assignedPlayers < +duel.type)
    );
  }
  isDuelFull(duel) {
    return +duel.assignedPlayers === +duel.type;
  }
  isDisabled(duel) {
    return (
      duel.status === DUEL_STATUSES.OPEN && +duel.assignedPlayers === +duel.type
    );
  }
}
</script>
<style lang="scss">
.list-duels {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
